import clsx from "clsx";
import { useClipboard } from "@/hooks/useClipboard";

/** Inline monospace value with one-click copy. */
export function MonoValue({
  value,
  className,
  truncate = false,
  onClick,
}: {
  value: string | number | null | undefined;
  className?: string;
  truncate?: boolean;
  onClick?: () => void;
}) {
  const { copy, copied } = useClipboard();
  if (value == null || value === "") {
    return <span className="font-mono text-fg-subtle">—</span>;
  }
  const text = String(value);
  return (
    <button
      type="button"
      title={copied ? "Copied" : `Click to copy: ${text}`}
      onClick={(e) => {
        e.stopPropagation();
        if (onClick) {
          onClick();
        } else {
          void copy(text);
        }
      }}
      className={clsx(
        "font-mono text-xs text-fg hover:text-accent focus:outline-none transition-colors",
        truncate && "max-w-[18ch] truncate align-bottom",
        className,
      )}
    >{text}</button>
  );
}
